import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { AffiliateDomainInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { NumberField, TextField } from './TextField'

export interface FormValues
  extends Omit<Partial<AffiliateDomainInput>, 'rate'> {
  rate?: string
}

export const AffiliateDomainForm: FC<FormProps<FormValues>> = flowMax(
  addDisplayName('AffiliateDomainForm'),
  addTranslationHelpers,
  ({ values, onChange, errors, t }) => (
    <div>
      <TextField
        id="domain"
        label={t('admin.resources.affiliateDomains.fields.domain')}
        value={values.domain ?? ''}
        onChange={(domain) => onChange({ ...values, domain })}
        error={errors.domain}
        focusOnMount
      />
      <NumberField
        id="rate"
        label={t('admin.resources.affiliateDomains.fields.rate')}
        value={values.rate ?? ''}
        onChange={(rate) => onChange({ ...values, rate })}
        error={errors.rate}
      />
    </div>
  )
)
